module.exports = __webpack_public_path__ + "5d2d6f4cfbacf19fd67a95ff8a700265.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/winter-chalet-main.png
// module id = 602
// module chunks = 0